import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'productReviews',
        value: 'Product Reviews',
      },
      {
        key: 'testimonialCarousel',
        value: 'Testimonial Carousel',
      },
      {
        key: 'allReviews',
        value: 'All Reviews',
      },
      {
        key: 'averageStoreRatingBadge',
        value: 'Average Store Rating Badge',
      },
      // {
      //   key: 'logoShowcaseBanner',
      //   value: 'Logo Showcase Banner',
      // },
      {
        key: 'inStoreMedia',
        value: 'In Store Media',
      },
      // {
      //   key: 'collectionPageCounter',
      //   value: 'Collection Page Counter',
      // },
      // {
      //   key: 'nonProductPageEventFeed',
      //   value: 'Non-product Page Event Feed',
      // },
      // {
      //   key: 'eventPopups',
      //   value: 'Event Popups',
      // },
      {
        key: 'averageRatingBadge',
        value: 'Average Rating Badge',
      },
      {
        key: 'productPageMedia',
        value: 'Product Page Media',
      },
      // {
      //   key: 'productPageCounter',
      //   value: 'Product Page Counter',
      // },
      // {
      //   key: 'productPageEventFeed',
      //   value: 'Product Page Event Fee',
      // },
    ],
    default_value: 'productReviews',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Fera Review Atom Module
 */
export class GpFeraReviewsFeatured extends GpThirdParty {
  public declare $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Fera Reviews';
  }

  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'fera-reviews';
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  isAutoRenderSetting() {
    return true;
  }
}
